// @ts-nocheck
/* eslint-disable */
export const catalogIcon = {
    data: `<svg
    class="catalog-nav-icon"
    viewBox="0 0 100 100"
    fill="none">
 <path
        class="lower-hexagon"
        d="M48.0833 2.83864C49.2694 2.15388 50.7306 2.15388 51.9167 2.83864L89.8846 24.7594C91.0706 25.4442 91.8013 26.7097 91.8013 28.0792V71.9208C91.8013 73.2903 91.0706 74.5558 89.8846 75.2406L51.9167 97.1614C50.7306 97.8461 49.2694 97.8461 48.0833 97.1614L10.1154 75.2406C8.92936 74.5558 8.19873 73.2903 8.19873 71.9208V28.0792C8.19873 26.7097 8.92936 25.4442 10.1154 24.7594L48.0833 2.83864Z"
        stroke-width="3" />
    <g style="mix-blend-mode: soft-light">
        <path
            class="upper-hexagon-shade"
            d="M50 8L87 29.7166V48.2875C87 48.2875 76.7767 57 50 57C24.6328 57 13 48.2875 13 48.2875V30L50 8Z" />
        <path
            d="M14 30.5688L50.0033 9.16146L86 30.2892V47.7954C85.9763 47.8127 85.9514 47.8308 85.9252 47.8495C85.6165 48.0712 85.1369 48.3955 84.474 48.7888C83.1485 49.5752 81.0886 50.6379 78.1951 51.7056C72.4099 53.8403 63.2778 56 50 56C37.4335 56 28.2975 53.8424 22.3246 51.7024C19.3372 50.632 17.1385 49.565 15.6954 48.7724C14.9739 48.376 14.4412 48.0482 14.0932 47.8227C14.0605 47.8015 14.0294 47.7812 14 47.7618V30.5688Z"
            stroke="black"
            stroke-opacity="0.01"
            stroke-width="2" />
    </g>

      <path
        d="M38.0003 66.4719H32.6668C31.9597 66.4711 31.2819 66.1899 30.7819 65.69C30.282 65.19 30.0008 64.5121 30 63.8051V37.1375C30.0008 36.4304 30.282 35.7526 30.7819 35.2526C31.2819 34.7527 31.9597 34.4715 32.6668 34.4707H38.0003C38.7073 34.4715 39.3852 34.7527 39.8851 35.2526C40.3851 35.7526 40.6663 36.4304 40.6671 37.1375V63.8051C40.6663 64.5121 40.3851 65.19 39.8851 65.69C39.3852 66.1899 38.7073 66.4711 38.0003 66.4719ZM32.6668 36.2485C32.431 36.2487 32.205 36.3424 32.0383 36.509C31.8717 36.6757 31.778 36.9017 31.7778 37.1375V63.8051C31.778 64.0408 31.8717 64.2668 32.0383 64.4335C32.205 64.6002 32.431 64.6939 32.6668 64.694H38.0003C38.236 64.6939 38.462 64.6002 38.6287 64.4335C38.7954 64.2668 38.8891 64.0408 38.8892 63.8051V37.1375C38.8891 36.9017 38.7954 36.6757 38.6287 36.509C38.462 36.3424 38.236 36.2487 38.0003 36.2485H32.6668Z"
        fill="var(--icon-text)" />
    <path
        d="M37.1113 41.582H33.5556C33.3199 41.582 33.0938 41.4884 32.927 41.3217C32.7603 41.155 32.6667 40.9289 32.6667 40.6931C32.6667 40.4574 32.7603 40.2313 32.927 40.0646C33.0938 39.8979 33.3199 39.8042 33.5556 39.8042H37.1113C37.347 39.8042 37.5731 39.8979 37.7399 40.0646C37.9066 40.2313 38.0002 40.4574 38.0002 40.6931C38.0002 40.9289 37.9066 41.155 37.7399 41.3217C37.5731 41.4884 37.347 41.582 37.1113 41.582Z"
        fill="var(--icon-text)" />
    <path
        d="M37.1113 61.1382H33.5556C33.3199 61.1382 33.0938 61.0445 32.927 60.8778C32.7603 60.7111 32.6667 60.485 32.6667 60.2493C32.6667 60.0135 32.7603 59.7874 32.927 59.6207C33.0938 59.454 33.3199 59.3604 33.5556 59.3604H37.1113C37.347 59.3604 37.5731 59.454 37.7399 59.6207C37.9066 59.7874 38.0002 60.0135 38.0002 60.2493C38.0002 60.485 37.9066 60.7111 37.7399 60.8778C37.5731 61.0445 37.347 61.1382 37.1113 61.1382Z"
        fill="var(--icon-text)" />
    <path
        d="M49.5566 66.4719H44.2231C43.5161 66.4711 42.8382 66.1899 42.3382 65.69C41.8383 65.19 41.5571 64.5121 41.5563 63.8051V37.1375C41.5571 36.4304 41.8383 35.7526 42.3382 35.2526C42.8382 34.7527 43.5161 34.4715 44.2231 34.4707H49.5566C50.2637 34.4715 50.9415 34.7527 51.4415 35.2526C51.9414 35.7526 52.2226 36.4304 52.2234 37.1375V63.8051C52.2226 64.5121 51.9414 65.19 51.4415 65.69C50.9415 66.1899 50.2637 66.4711 49.5566 66.4719ZM44.2231 36.2485C43.9874 36.2487 43.7614 36.3424 43.5947 36.509C43.428 36.6757 43.3343 36.9017 43.3342 37.1375V63.8051C43.3343 64.0408 43.428 64.2668 43.5947 64.4335C43.7614 64.6002 43.9874 64.6939 44.2231 64.694H49.5566C49.7923 64.6939 50.0184 64.6002 50.185 64.4335C50.3517 64.2668 50.4454 64.0408 50.4455 63.8051V37.1375C50.4454 36.9017 50.3517 36.6757 50.185 36.509C50.0184 36.3424 49.7923 36.2487 49.5566 36.2485H44.2231Z"
        fill="var(--icon-text)" />
    <path
        d="M48.6676 41.582H45.1119C44.8762 41.582 44.6501 41.4884 44.4834 41.3217C44.3167 41.155 44.223 40.9289 44.223 40.6931C44.223 40.4574 44.3167 40.2313 44.4834 40.0646C44.6501 39.8979 44.8762 39.8042 45.1119 39.8042H48.6676C48.9034 39.8042 49.1295 39.8979 49.2962 40.0646C49.4629 40.2313 49.5565 40.4574 49.5565 40.6931C49.5565 40.9289 49.4629 41.155 49.2962 41.3217C49.1295 41.4884 48.9034 41.582 48.6676 41.582Z"
        fill="var(--icon-text)" />
    <path
        d="M48.6676 61.1382H45.1119C44.8762 61.1382 44.6501 61.0445 44.4834 60.8778C44.3167 60.7111 44.223 60.485 44.223 60.2493C44.223 60.0135 44.3167 59.7874 44.4834 59.6207C44.6501 59.454 44.8762 59.3604 45.1119 59.3604H48.6676C48.9034 59.3604 49.1295 59.454 49.2962 59.6207C49.4629 59.7874 49.5565 60.0135 49.5565 60.2493C49.5565 60.485 49.4629 60.7111 49.2962 60.8778C49.1295 61.0445 48.9034 61.1382 48.6676 61.1382Z"
        fill="var(--icon-text)" />
    <path
        d="M62.1771 66.4721C61.5908 66.4707 61.0214 66.2762 60.5567 65.9187C60.0921 65.5612 59.7582 65.0605 59.6066 64.4942L52.7043 38.7359C52.6135 38.3976 52.5903 38.0448 52.636 37.6976C52.6816 37.3504 52.7952 37.0155 52.9703 36.7122C53.1454 36.4089 53.3786 36.1431 53.6564 35.9299C53.9343 35.7168 54.2514 35.5604 54.5898 35.4699L59.7412 34.0893C60.4243 33.9082 61.1512 34.0048 61.7633 34.358C62.3754 34.7112 62.8227 35.2923 63.0077 35.9743L69.91 61.7336C70.0919 62.4167 69.9955 63.144 69.6421 63.7562C69.2887 64.3684 68.707 64.8155 68.0246 64.9996L62.8721 66.3801C62.6455 66.4411 62.4118 66.472 62.1771 66.4721ZM60.431 35.7742C60.3534 35.7744 60.2761 35.7846 60.2011 35.8046L55.0501 37.1866C54.9372 37.2168 54.8313 37.269 54.7386 37.3402C54.6459 37.4114 54.5681 37.5002 54.5097 37.6014C54.4513 37.7027 54.4135 37.8145 54.3983 37.9304C54.3832 38.0463 54.3911 38.1641 54.4215 38.277L61.3237 64.0343C61.3538 64.1474 61.4059 64.2533 61.4771 64.3461C61.5482 64.439 61.637 64.5168 61.7383 64.5752C61.8397 64.6336 61.9515 64.6715 62.0675 64.6865C62.1835 64.7016 62.3013 64.6936 62.4142 64.663L67.5661 63.2829C67.7939 63.2214 67.988 63.072 68.1058 62.8676C68.2236 62.6632 68.2556 62.4205 68.1948 62.1925L61.2906 36.4351C61.2399 36.2458 61.1282 36.0784 60.9728 35.959C60.8175 35.8395 60.627 35.7746 60.431 35.7742Z"
        fill="var(--icon-text)" />
    <path
        d="M57.0584 42.1392C56.843 42.1385 56.6353 42.0596 56.4737 41.9173C56.3121 41.775 56.2076 41.5789 56.1796 41.3654C56.1516 41.1518 56.2021 40.9354 56.3216 40.7563C56.4411 40.5771 56.6215 40.4474 56.8294 40.3913L60.2642 39.472C60.4912 39.4129 60.7324 39.446 60.9352 39.5641C61.138 39.6821 61.2858 39.8755 61.3466 40.1021C61.4073 40.3287 61.376 40.5702 61.2595 40.7738C61.143 40.9774 60.9507 41.1267 60.7245 41.1892L57.2893 42.1094C57.2139 42.1292 57.1363 42.1393 57.0584 42.1392Z"
        fill="var(--icon-text)" />
    <path
        d="M62.1198 61.0289C61.9044 61.0282 61.6966 60.9494 61.5349 60.8072C61.3732 60.6649 61.2686 60.4688 61.2406 60.2552C61.2126 60.0417 61.263 59.8252 61.3825 59.646C61.502 59.4668 61.6824 59.3371 61.8904 59.2809L65.3247 58.3607C65.5517 58.3016 65.7929 58.3347 65.9957 58.4527C66.1984 58.5708 66.3463 58.7642 66.4071 58.9908C66.4678 59.2174 66.4365 59.4588 66.32 59.6625C66.2035 59.8661 66.0112 60.0154 65.785 60.0778L62.3507 60.998C62.2754 61.0185 62.1978 61.0288 62.1198 61.0289Z"
        fill="var(--icon-text)" />


      <defs>
        <linearGradient
            id="paint0_linear_dark"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#4FC8EC" />
            <stop
                offset="1"
                stop-color="#2D3792" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_dark"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#2D3792" />
            <stop
                offset="1"
                stop-color="#4FC8EC" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_dark"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>

        <linearGradient
            id="paint0_linear_light"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#1D53A4" />
            <stop
                offset="1"
                stop-color="#1C3664" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_light"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1C3664" />
            <stop
                offset="1"
                stop-color="#1D53A4" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_light"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>
    </defs>
</svg>


`,
    name: 'catalog-alt' as const
};